<template>
  <div class="legal container">
    <div v-if="title">
      <h2>上海斐宸2022年度总结大会圆满落幕！</h2>
      <h4>日月更迭，光影流转，时空的坐标轴镌刻每一步奋斗的足迹，记忆的快门声定格每一帧拼搏的瞬间。</h4>
      <div class="legal-notice">
        <h4>2023年1月12日-1月14日，在会议厅内举办了为期三天的斐宸年度总结大会，全体成员齐聚一堂。回望2022，上海斐宸全体员工，用汗水浇灌梦想，用努力诠释担当，以真抓实干和敢打敢拼，奏响了加快高质量发展奋进的乐章。</h4>
        <div class="container">
          <img src="../../assets/img/news/summary_1.png" alt="" />
        </div>
      </div>
      <div class="legal-notice">
        <h4>会议首先以个人为单位汇报工作总结，各部门主管更是进行了详细的数据化演示，大家都交了令人满意的答卷，肯定成绩，表彰优秀。我们通过总结汇报，以便查漏补缺，为下一年的奋战做好准备。</h4>
        <div class="container">
          <img src="../../assets/img/news/summary_2.png" alt="" />
        </div>
      </div>
      <div class="legal-notice">
        <h4>会议上对优秀员工进行了隆重表彰，一本本荣誉证书，是日积月累辛勤的付出，是一份荣耀，也是未来践行梦想的动力。辛勤播种必定硕果累累，在他们获得荣耀的同时，必定付出了比别人多百倍的努力。在过去一年的时间里，他们不但创造了优异的成绩，更为我们树立了“团结协作，吃苦耐劳，勇于担当，敬业奉献”的榜样。</h4>
        <div class="container">
          <img src="../../assets/img/news/summary_3.png" alt="" />
        </div>
      </div>
      <div class="legal-notice">
        <h4>胜利皆由努力来，成就与勤奋相辉映，升职是最好的证明。对优秀的领导，公司在本次会议中给予了晋升。未来将通过制度的优化，新目标的树立，更加严于律己，加强作风建设；强化职能，提高工作效率。千里之行始于足下，要认真落实每一项工作；细节决定成败，要认真抓好每一个细节。相信在各部门总监的带领下，我们的团队必定有更大的突破。</h4>
        <div class="container">
          <img src="../../assets/img/news/summary_4.png" alt="" />
        </div>
      </div>
      <div class="legal-notice">
        <h4>会议的第三部分是管理层和市场部的培训工作。2023年，我们将适应新的市场环境，实施新的经营战略，开拓新的业务领域。通过数据分析，研究新兴市场，把握未来市场发展方向，根据市场趋势，制定新的经营策略，为公司发展带来更多机遇。</h4>
        <div class="container">
          <img src="../../assets/img/news/summary_5.png" alt="" />
        </div>
      </div>
      <div class="legal-notice">
        <h4>新的工作计划和工作目标是每个斐宸人心中不变的信念，我们相信每一句誓言，都是团队思想统一，誓保指标的决心。复杂的环境更考验我们团队的作战能力和应变能力。面对竞争激烈的市场，我们必须主动拥抱变化，保持清醒头脑，继续夯实基础，苦练内功，才能不断的提升战斗力。</h4>
        <div class="container">
          <img src="../../assets/img/news/summary_6.png" alt="" />
        </div>
      </div>
      <div class="legal-notice">
        <h4>金虎一跃乘风去，玉兔送福携春来，历史的画卷，在砥砺前行中铺垫，时代的华章，在接续奋斗中书写。感恩彼此相伴的时光，感念不期而遇的温暖。新年曙光已经照耀在神州大地，让我们满怀信心与期待，迎接2023年的到来！</h4>
        <div class="container">
          <img src="../../assets/img/news/summary_7.png" alt="" />
        </div>
      </div>
    </div>
    <div v-else>
      <h2>智慧校园建设团队特点及定义</h2>
      <h4>
        智慧校园指的是以物联网为基础的智慧化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理 和校园生活进行充分融合。2010年，在信息化“十二五”规划中，浙江大学提出建设一个“令人激动”的“智慧校园”。这幅蓝图描绘的是：无处不在
        的网络学习、融合创新的网络科研、透明高效的校务治理、丰富多彩的校园文化、方便周到的校园生活。简而言之，“要做一个安全、稳定、环保、节 能的校园。”2018年6月7日，国家标准《智慧校园总体框架》（Smart campus overall framework）发布。
      </h4>
      <!-- 智慧校园建设团队的特点 -->
      <div class="legal-notice">
        <h3>智慧校园建设团队的特点</h3>
        <ol type="1">
          <li>团队构成极其复杂，涉及部门机构较多，团队成员的工作情境和专业背景差距较大，存在沟通协调困难的潜在因素[3]</li>
          <li>建设团队需要有较高的信息素养，尤其是智慧校园建设的负责人需要既掌握智慧校园建设理论又知晓智慧校园建设技术。[3]</li>
          <li>建设团队应该善于追踪物联网、大数据、物联网、学习分析、机器人、人工智能等新技术与新媒体的发展，及时关注教育中的热点问题，富有创 新精神，能够创造性地对智慧校园进行规划与设计，切实解决教育发展中的具体问题。[3]</li>
          <li>建设团队想要做好智慧校园的规划与设计，必须对智慧校园内涵、功能和作用达成基本共识，与国家的相关政策保持高度一致，关注教育中的热 点问题，并突出彰显本地化特色。</li>
        </ol>
        <div class="container">
          <img src="../../assets/img/news/zhxy_image.png" alt="" />
        </div>
      </div>
      <!-- 智慧校园建设概述 -->
      <div class="legal-notice">
        <h3>智慧校园建设概述</h3>
        <h4>
          如同智慧地球一样，“智慧校园”与时下如火如荼的物联网技术密不可分。IDC 的最新数据预测，截至2020年，全球将有310亿个互联设备联网工 作。届时，人们将体验到连续的、无处不在的互联网。而“智慧校园”的首要目标，也正是通过物联网技术，连接校园网中的各个物件。从技术上来说，
          智慧的地球涉及用RFID、二维码、视频监控等感知技术和设备。但是“智慧校园”到底是什么？作为一个崭新的概念，不同的提出者给予不同的诠释， 这现象类似于当初的云计算。厂商的参与使得“智慧校园”与特定的产品捆绑，如由江苏省电信所倡导的“智慧校园”，其重要载体是校园“翼机通” 通过融合物联网与3G
          技术的信息化应用平台，‘翼机通’手机集门禁卡、借书证、零钱包等用途于一身。”中国电信的宣传文章上写着。同样可以预见 的是，在运营商对学校市场高度青睐的今天，有可能下一个想从“智慧校园”中分得一杯羹的会是移动或者联通，还是微校通。他们同样也会对“智慧
          校园”有基于自身产品的诠释。因此，相关质疑免不了产生：由厂商所提出并且实施的“智慧校园”是否可以让高校的信息化健康、稳健、可持续发展？ 江苏某高校一位信息化工作者旗帜鲜明地表示：“由厂商主导的‘智慧校园’和以前由银行主导建设一卡通存在着同样的机遇和问题。”
        </h4>
        <h4>
          此外，智慧校园与数字校园的区别是什么？这几乎是每个接触到“智慧校园”概念的人共同的问题。一些人认为，“智慧校园”是数字校园升级到 一定阶段的表现，是数字校园发展的一个阶段。由此，可以看到的是，“智慧校园”的基石是前期数字校园的建设与发展。也就意味着，“智慧校园”
          首先要有一个统一的基础设施平台，要拥有有线与无线双网覆盖的网络环境；其次，要有统一的数据共享平台和综合信息服务平台。
        </h4>
      </div>
      <!-- 分割线 -->
      <div class="splitline"></div>
      <!-- 切换篇数 -->
      <div class="changepage">
        <p>上一篇：智慧校园</p>
        <p>下一篇：智慧校园</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Newsdetail',
  data() {
    return {
      title: '',
    };
  },
  mounted() {
    this.title = this.$route.params.title;
  },
};
</script>
<style scoped>
.legal {
  margin-bottom: 100px;
}
.legal h2 {
  margin: 100px;
  text-align: center;
  font-size: 48px;
  color: #333;
  font-weight: bold;
}
.legal h4 {
  font-size: 18px;
  font-weight: 400;
  text-indent: 2em;
  line-height: 1.7;
  color: #666;
}
.legal-notice h3 {
  margin-top: 100px;
  margin-bottom: 39px;
  font-size: 24px;
  font-weight: bold;
}
.legal-notice ol {
  text-indent: 2em;
  margin-bottom: 40px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  color: #666;
}
.legal-notice img {
  width: 100%;
  height: 100%;
  margin-top: 50px;
}
.splitline {
  margin-top: 39px;
  width: 1200px;
  height: 1px;
  background-color: #cccccc;
}
.changepage {
  margin-top: 40px;
  font-size: 18px;
  font-weight: 400;
  color: #666;
  display: flex;
  justify-content: space-between;
}
</style>
